import gql from 'graphql-tag';

export const GET_PROCESS_LIST = gql`
  {
    grabGetProcessList {
      id
      status
      statsGeneral {
        channelsProcessed
        averageLoad
      }
      total_runtime
      created_at
      batch {
        name
        color
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/grab/list.js